module.exports = __webpack_public_path__ + "static/media/icon-todo-reminder.d07af87e.svg";